import getEntityDefaultListComponent from 'src/utils/entityOperations/propertyGetters/getEntityDefaultListComponent';
import genericTableInMenuItem from './genericTableInMenuItem';
/**
 * This function creates a MenuItem object's ```setCurrentModeParams``` prop that will open a Default List component or defaults to GenericTable. It takes ```GenericTableProps``` but can take just ```LocalEntityName``` string by way of syntactic sugar.
 */
export default function genericListComponentInMenuItem(params) {
    const passedProps = (typeof params !== 'string') ? params : undefined;
    const localEntityName = passedProps ? passedProps.localEntityNameProp : params;
    if (!localEntityName)
        throw new Error('localEntityNameProp is required');
    // If the passedProps object does not have a tableIdProp, then add it.
    if (passedProps && !(passedProps === null || passedProps === void 0 ? void 0 : passedProps.tableIdProp))
        passedProps.tableIdProp = localEntityName.replace(/\./g, '__');
    const defaultListComponent = getEntityDefaultListComponent(localEntityName);
    return defaultListComponent
        ? {
            setCurrentModeParams: {
                component: defaultListComponent,
                componentProps: passedProps || { localEntityNameProp: localEntityName }
            }
        }
        : genericTableInMenuItem(params);
}
